import React, { Component } from "react";
import { debounce } from "lodash";

import api from "services/api";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as StoresActions,
  Selectors as StoresSelectors,
} from "store/ducks/stores";

import { Form } from "components";

class Filters extends Component {
  state = {
    professionals: [],
  };

  constructor(props) {
    super(props);

    this.searchProfessionals = debounce(async (value) => {
      if (value.length < 11) {
        this.setState({ professionals: [] });
        return;
      }

      try {
        const response = await api.get(`user/v2/inhabitants/cpf/${value}`);
        const { data } = response.data;

        this.setState({
          professionals: [
            {
              value: value,
              label: `${data.attributes.name} (${value})`,
            },
          ],
        });
      } catch (err) {
        this.setState({ professionals: [] });
      }
    }, 300);
  }

  handleSearchProfessional = (value) => {
    this.searchProfessionals(value);
  };

  render() {
    const { professionals } = this.state;
    const { data, onChange, onClean, onSubmit } = this.props;

    return (
      <Form className="row form-filters">
        <Form.Field className="col-md-3 col-sm-4">
          <Form.Label>CPF do Profissional</Form.Label>
          <Form.Select
            placeholder="Digite o CPF do profissional"
            noOptionsMessage={() => "Nenhum profissional encontrado."}
            options={professionals}
            onInputChange={this.handleSearchProfessional}
            onChange={value => onChange("professional_cpf", value)}
            value={data.professional_cpf}
            isClearable
          />
        </Form.Field>

        <Form.Field className="col-md-2 col-sm-4">
          <Form.Label>Data</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.created_at}
              onChange={async (value) => onChange("created_at", value)}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-3 col-sm-4">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar Filtro
          </Form.Button>

          <Form.Button
            className="button-apply-filter"
            type="buton"
            onClick={onSubmit}
          >
            Aplicar Filtro
          </Form.Button>
        </Form.Field>
      </Form>
    );
  }
}

const mapstate = (state) => ({
  stores: {
    ...state.stores,
    data: StoresSelectors.options(state.stores.data),
  },
});

const mapActions = (dispatch) =>
  bindActionCreators({ ...StoresActions }, dispatch);

export default connect(mapstate, mapActions)(Filters);
